import { render, staticRenderFns } from "./DefaultFlag.vue?vue&type=template&id=d9ec92f4"
import script from "./DefaultFlag.vue?vue&type=script&lang=js"
export * from "./DefaultFlag.vue?vue&type=script&lang=js"
import style0 from "./DefaultFlag.vue?vue&type=style&index=0&id=d9ec92f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports